import { useState } from 'react';
import dayjs, { type Dayjs } from 'dayjs';
import { useMutation } from '@tanstack/react-query';
import { Box, Button, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { getPersonnelSalesReport } from '../../../api/endpoints/salesReports';
import { salesReportRows } from '../../../api/types/salesReports';
import { ApiErrorAlert } from '../../../components/ApiErrorAlert';
import { DynamicReportTable } from '../../../components/report/DynamicReportTable';
import { SalesReportTotals } from '../../../components/report/SalesReportTotals';

/** "Personel Satış Raporu" (legacy `Report/PersonelSalesReport`). */
export default function PersonnelSalesReportPage() {
  const [start, setStart] = useState<Dayjs | null>(dayjs().startOf('month'));
  const [end, setEnd] = useState<Dayjs | null>(dayjs());

  const report = useMutation({
    mutationFn: () =>
      getPersonnelSalesReport({
        startDate: (start ?? dayjs()).format('YYYY-MM-DD'),
        endDate: (end ?? dayjs()).format('YYYY-MM-DD'),
      }),
  });

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Personel Satış Raporu
      </Typography>

      <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <DatePicker label="Başlangıç" value={start} onChange={setStart} slotProps={{ textField: { size: 'small' } }} />
          <DatePicker label="Bitiş" value={end} onChange={setEnd} slotProps={{ textField: { size: 'small' } }} />
          <Button variant="contained" onClick={() => report.mutate()} disabled={report.isPending}>
            {report.isPending ? 'Getiriliyor…' : 'Raporu Getir'}
          </Button>
        </Stack>
        <ApiErrorAlert error={report.error} sx={{ mt: 2 }} />
      </Paper>

      {report.isPending && <CircularProgress size={24} />}
      {report.isSuccess && (
        <>
          <SalesReportTotals data={report.data} />
          <DynamicReportTable rows={salesReportRows(report.data)} fileName="personel-satis-raporu" />
        </>
      )}
    </Box>
  );
}
